import Model from 'core/model/Model';

export default class CompanyNoteModel extends Model {
  get urlRoot() {
    return '/api/ui/sudo/notes';
  }
}
